import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React from 'react'

import social from '../../styles/components/social'

const platforms = [
  { name: 'email', className: 'email', icon: ['far', 'envelope'] },
  { name: 'twitter', className: 'twitter', icon: ['fab', 'x-twitter'] },
  { name: 'linkedin', className: 'linkedin', icon: ['fab', 'linkedin'] },
  { name: 'instagram', className: 'instagram', icon: ['fab', 'instagram'] },
  { name: 'facebook', className: 'facebook', icon: ['fab', 'facebook'] }
]

const Social = ({ entity }) => (
  <div className='social'>
    {platforms.map(p => {
      if (!entity?.[p.name]) {
        return null
      }

      const href = p.name === 'email' ? `mailto:${entity[p.name]}` : entity[p.name]

      return (
        <a key={p.name} href={href} className={p.className} target='_blank'>
          <FontAwesomeIcon icon={p.icon} size='lg' />
        </a>
      )
    })}
    <style jsx>{social}</style>
  </div>
)

export default Social
